module.exports = __webpack_public_path__ + "static/media/ninx10.0d3d2a72.jpg";